import Sidebar from "../Sidebar/Sidebar";

import { Route, Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import DashboardHeaderActions from "../StudyDashboard/components/DashboardHeaderActions";

import ExploreMotionTopBar from "./ExploreMotionTopBar";
import LoaderPopUp from "../loader/loader";

import "./DashboardLayout.css";

import DashboardCourses from "../DashboardCourses/DashboardCourses";
import DashboardBooks from "../DashboardBooks/DashboardBooks";

const DashboardLayout = () => {
  const location = useLocation();
  const isLoaderVisible = useSelector((state) => state.ui.loader);

  const isCoursesPage =
    location.pathname === "/dashboard/courses" ||
    location.pathname.startsWith("/dashboard/courses/");

  if (location.pathname === "/dashboard") {
    return <Redirect to="/user_dashboard" />;
  }

  return (
    <div
      className={`dashboard-layout${
        isCoursesPage ? " dashboard-layout--courses" : ""
      }`}
    >
      {!isCoursesPage ? <Sidebar /> : null}

      <div className="dashboard-main">
        {isCoursesPage ? (
          <ExploreMotionTopBar />
        ) : (
          <div className="dashboard-top-bar">
            <DashboardHeaderActions />
          </div>
        )}

        <div className="dashboard-content">
          <Route exact path="/dashboard/courses" component={DashboardCourses} />
          <Route
            exact
            path="/dashboard/courses/books"
            component={DashboardBooks}
          />
        </div>
      </div>

      {isLoaderVisible ? <LoaderPopUp /> : null}
    </div>
  );
};

export default DashboardLayout;
